import { camelCase } from 'lodash';

import { contentstackLivePreviewSdk } from 'utils/contentstackLivePreviewSdk';

const exceptionsMap: Record<string, string> = {
  fullbleed_cta: 'fullBleedCta',
  column_header_internal_: 'columnHeaderInternal',
};

export const convertKeysToCamelCase = <T>(obj: T): T => {
  if (Array.isArray(obj)) {
    return obj.map(convertKeysToCamelCase) as T;
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const newKey = key.startsWith('_') ? key : exceptionsMap[key] || camelCase(key);
      (acc as Record<string, T>)[newKey] = convertKeysToCamelCase((obj as Record<string, T>)[key]);

      return acc;
    }, {} as T);
  }

  return obj;
};

export const getLivePreviewParams = () => {
  return {
    timestamp: contentstackLivePreviewSdk?.timelineConfig?.timestamp,
    hash: contentstackLivePreviewSdk?.timelineConfig?.hash || contentstackLivePreviewSdk?.stackSdk?.live_preview?.hash,
  };
};

export const getTimelineConfig = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentUrl = new URL(document.URL);
  const params = new URLSearchParams(currentUrl.search);
  const timestamp = params.get('preview_timestamp');
  const hash = params.get('live_preview');

  if (!timestamp || !hash) {
    return null;
  }

  return { timestamp, hash };
};
